import { Box } from "@mui/system";
import BudgetDateFilter from "./BudgetContent/BudgetDateFilter";
import BudgetSearchItems from "./BudgetContent/BudgetSearchItems";
import BudgetSearchFilter from "./BudgetContent/BudgetSearchFilter";
import { useDispatch, useSelector } from "react-redux";
import { selectUserToken } from "../../../../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import {
  setFilteredRecordsForBudgetMobile,
  setHasDataFetchedForBudgetMobile,
  setIsLoadingMobileBizLeader,
  setSelectedBrandForBudget,
  setSortForBudget,
} from "../../../../../../../../features/businessLeaderDashboardSlice";
import { budgetQueryId } from "../../../helpers/QIDs";
import { buiDashboardEndPointLogicMobile } from "../../../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboardMobile/buiDashboardEndPointLogicMobile";
import RecentSkeleton from "../../../helpers/RecentSkeleton";
import { useWorkspaceChange } from "../../../../hooksForBD/useWorkspaceChange";

const Budget = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as string | any;
  const [searchParams, setSearchParams] = useSearchParams();
  const websiteSharedUids = searchParams.get("workspace");
  const startDate = searchParams.get("startDateForBudget");
  const endDate = searchParams.get("endDateForBudget");
  const dispatch = useDispatch();

  const {
    hasDataFetchedForBudgetMobile,
    isLoadingMobileBizLeader,
    budgetDataListMobile,
  } = useSelector((state: any) => state.businessLeaderDashBoard);

  useEffect(() => {
    if (
      !oauthTokenHeader ||
      !websiteSharedUids ||
      !startDate ||
      !endDate ||
      isLoadingMobileBizLeader
    ) {
      return;
    }
    const fetchData = async () => {
      try {
        dispatch(setIsLoadingMobileBizLeader(true));
        dispatch(setHasDataFetchedForBudgetMobile(false));
        const dimensionResponse =
          await buiDashboardEndPointLogicMobile.getDimensionInBizLeaderDashboardMobile(
            oauthTokenHeader,
          );
        if (!dimensionResponse || dimensionResponse.status !== 200) {
          return;
        }
        const dimensions = dimensionResponse?.data?.data || [];
        const matchedDimensions = dimensions
          ?.filter((dim: any) =>
            dim.websites?.some(
              (site: any) => site.shared_uid === websiteSharedUids,
            ),
          )
          ?.map((dim: any) => dim.dimension);
        if (!matchedDimensions?.length) return;
        await Promise.all([
          buiDashboardEndPointLogicMobile.getBudgetListMobile({
            oauthTokenHeader,
            queryId: budgetQueryId,
            websiteSharedUids: websiteSharedUids?.split(",") || [],
            type: "site",
            startDate: startDate,
            endDate: endDate,
            dimension: matchedDimensions || [],
          }),
        ]);
      } finally {
        dispatch(setIsLoadingMobileBizLeader(false));
        dispatch(setHasDataFetchedForBudgetMobile(true));
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, websiteSharedUids, oauthTokenHeader]);

  // clear the brand filter when workspace changes
  useWorkspaceChange(
    useCallback(() => {
      dispatch(setFilteredRecordsForBudgetMobile([])); // clear filtered records on date change
      dispatch(setSelectedBrandForBudget("")); //clear selected brand in Redux
      dispatch(
        setSortForBudget({
          keytoSort: "qftd",
          direction: "asc",
          label: "QFTD",
        }),
      ); // reset sorting to default on date change
      setSearchParams(
        (prev) => {
          prev.delete("searchBrandForBudget");
          return prev;
        },
        { replace: true },
      ); // remove brand filter from URL
    }, [dispatch, setSearchParams]),
  );

  return (
    <Box sx={{ px: 2 }}>
      <BudgetDateFilter />

      {isLoadingMobileBizLeader && <RecentSkeleton />}

      {!isLoadingMobileBizLeader && hasDataFetchedForBudgetMobile && (
        <>
          {budgetDataListMobile?.length > 0 && <BudgetSearchFilter />}
          <BudgetSearchItems />
        </>
      )}
    </Box>
  );
};

export default Budget;
